'use client';

import styled from 'styled-components';

import { Sheet } from '@zoomit/mobile-sheet';
import { Box, Flex, Spacing } from '@zoomit/primitives';
import type { BuyingGuideResponseItem } from '@zoomit/web-kit';
import { Anchor, Button, cssVar, RedDot, theme, Typography } from '@zoomit/zoomit-ds';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  categorySlug: string;
  items: BuyingGuideResponseItem[];
};

const BuyingGuideDetailsMobileSheet = (props: Props) => {
  const { onClose, items, isOpen, categorySlug } = props;

  return (
    <>
      <Sheet isOpen={isOpen} onClose={onClose} disableDrag>
        <Sheet.Container hasBorderRadius>
          <Sheet.Header>
            <Flex spacing={{ px: 'x11', pt: 'x10' }}>
              <Title>
                <Typography fontSize={1.6} fontWeight="bold" lineHeight={1.75}>
                  راهنماهای خریدی که این محصول در آن‌ها پیشنهاد شده
                </Typography>
              </Title>
            </Flex>
          </Sheet.Header>
          <Sheet.Content style={{ position: 'relative' }}>
            <Box spacing={{ px: 'x11', pt: 'x2' }}>
              <Typography tag="p" fontSize={1.4} lineHeight={2} textColor={cssVar(theme.grey1)}>
                با انتخاب هر راهنمای خرید، لیست کاملی از محصولات پیشنهادی زوبین را مشاهده کنید.
              </Typography>
              <Box
                className="h-[calc(100vh-226px)] overflow-y-auto"
                backgroundColor={cssVar(theme.background2)}
                spacing={{ pt: 'x4', pb: 'x16' }}
              >
                <Flex spacing={{ pb: 'x2' }} flexDirection="column" gap={Spacing.x2}>
                  {items.map(({ id, title, defaultSort }) => (
                    <BuyingGuideAnchor
                      key={id}
                      href={`/list/${categorySlug}?buyingGuideIds=${id}&sort=${defaultSort}`}
                      className="fa"
                    >
                      <RedDot />
                      <Typography fontSize={1.4} fontWeight="bold" lineHeight={2}>
                        {title}
                      </Typography>
                    </BuyingGuideAnchor>
                  ))}
                </Flex>
              </Box>
            </Box>
            <ActionBox spacing={{ py: 'x4', px: 'x11' }}>
              <Button type="button" variant="outline" size="full width" onClick={onClose}>
                بستن
              </Button>
            </ActionBox>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop />
      </Sheet>
    </>
  );
};

export default BuyingGuideDetailsMobileSheet;

const ActionBox = styled(Flex)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(${theme.grey7});
`;

const BuyingGuideAnchor = styled(Anchor)`
  display: flex;
  justify-content: flex-start;
  padding: ${Spacing.x2}rem;
  width: 100%;
  flex: 1;
  border-radius: var(${theme.radius.md});
  border: solid 1px var(${theme.grey6});
`;

const Title = styled.div`
  position: relative;
  margin-right: 1.2rem;

  ::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 2.4rem;
    top: calc(50% - 1.2rem);
    right: -1.2rem;
    background-color: var(${theme.primary1});
  }
`;
